import { render, staticRenderFns } from "./BulkClassifyFailuresDialog.vue?vue&type=template&id=5f0e2eae&scoped=true"
import script from "./BulkClassifyFailuresDialog.vue?vue&type=script&lang=js"
export * from "./BulkClassifyFailuresDialog.vue?vue&type=script&lang=js"
import style0 from "./BulkClassifyFailuresDialog.vue?vue&type=style&index=0&id=5f0e2eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e2eae",
  null
  
)

export default component.exports